<div class="pt-2 pb-3">
    <div *ngFor="let tagItem of userTagsList" class="tag-btn">
        <div class="d-flex flex-row align-items-center justify-content-between">{{ tagItem.tag.name }} <i class="pi pi-times-circle ml-2" (click)="confirmTagsDelete(tagItem)"></i></div>
    </div>
</div>
<p-dropdown [options]="tagOptions" [(ngModel)]="selectedTag" [filter]="true" optionLabel="name" placeholder="Select Tag" styleClass="w-100" (onChange)="confirmAddTag($event)"></p-dropdown>

<p-confirmDialog styleClass="dark-glass-dialog" key="leadTags" [style]="{ width: '50vw' }" [baseZIndex]="10000"></p-confirmDialog>
